export type OptionSelectionCount = number | 'any';

export enum ValidationOperator {
  IS_EQUAL = 'IS_EQUAL',
  HAS_ANSWER = 'HAS_ANSWER',
  DOES_NOT_HAVE_ANSWER = 'DOES_NOT_HAVE_ANSWER',
  AT_LEAST = 'AT_LEAST',
}

export interface ValidationRule {
  selectionCount: OptionSelectionCount;
  operator: ValidationOperator;
  minCount?: number;
  selectedOptionIds: string[];
}
